import { createId } from '@shared/utils/createId';

const deviceIdKey = 'fuelops.device_id';

export const deviceIdentity = {
  getDeviceId() {
    let deviceId = window.localStorage.getItem(deviceIdKey);

    if (!deviceId) {
      deviceId = createId();
      window.localStorage.setItem(deviceIdKey, deviceId);
    }

    return deviceId;
  },
  getDeviceName() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform || 'Web';
    const browser =
      userAgent.includes('CriOS') || userAgent.includes('Chrome')
        ? 'Chrome'
        : userAgent.includes('Safari')
          ? 'Safari'
          : 'Browser';

    return `${platform} ${browser}`.trim();
  }
};
